// Quick Order Functionality

document.addEventListener('DOMContentLoaded', function() {
  // Elements
  const csvInput = document.getElementById('quick-order-csv-input');
  const importBtn = document.getElementById('quick-order-import-btn');
  const dropzone = document.getElementById('quick-order-dropzone');
  const csvErrors = document.getElementById('quick-order-csv-errors');
  const autocompleteBox = document.getElementById('quick-order-autocomplete');
  const tableSearchSku = document.querySelector('[data-role="qo-table-search-sku"]');
  const tableSearchQty = document.querySelector('[data-role="qo-table-search-qty"]');
  const tableSearchMessage = document.querySelector('[data-role="qo-table-search-message"]');
  const tableBody = document.querySelector('#quick-order-table tbody');
  const tableSearchRow = document.querySelector('[data-role="qo-table-search-row"]');
  const tableErrors = document.getElementById('quick-order-table-errors');
  const addToCartBtn = document.getElementById('quick-order-add-to-cart-btn');
  const addToCartMsg = document.getElementById('quick-order-addtocart-message');
  const container = document.querySelector('.custom-quick-order-container');
  
  // Get currency symbol from data attribute, default to $ if not found
  const currencySymbol = container?.dataset?.currencySymbol || '$';

  // State - the quick order items to show in the table
  let quickOrderItems = [];

  function toggleLoader(show) {
    const loader = document.getElementById('quick-order-loader');
    if (loader) {
      loader.style.display = show ? 'block' : 'none';
    }
  }

  // CSV Import Handler
  if (importBtn) {
    importBtn.addEventListener('click', function() {
      if (!csvInput.files || !csvInput.files.length) {
        csvInput.click();
        return;
      }
      handleCSVImport({ target: csvInput });
    });
  }
  
  // Clear errors when file input changes
  if (csvInput) {
    csvInput.addEventListener('change', function() {
      if (csvErrors) {
        csvErrors.textContent = '';
        csvErrors.classList.remove('is-error', 'is-success');
      }
    });
  }
  
  if (dropzone) {
    ['dragenter','dragover'].forEach(evt => dropzone.addEventListener(evt, e => { e.preventDefault(); dropzone.classList.add('is-dragover'); }));
    ['dragleave','drop'].forEach(evt => dropzone.addEventListener(evt, e => { e.preventDefault(); dropzone.classList.remove('is-dragover'); }));
    dropzone.addEventListener('drop', e => {
      const dt = e.dataTransfer;
      if (!dt || !dt.files || !dt.files.length) return;
      const file = dt.files[0];
      csvInput.files = dt.files;
      // Clear errors when file is dropped
      if (csvErrors) {
        csvErrors.textContent = '';
        csvErrors.classList.remove('is-error', 'is-success');
      }
      handleCSVImport({ target: { files: [file] } });
    });
  }

  // Quick table search handlers
  if (tableSearchSku) {
    const debouncedAutocomplete = debounce(handleAutocomplete, 300);

    tableSearchSku.addEventListener('input', () => {
      setTableSearchMessage('');
      debouncedAutocomplete();
    });
    tableSearchSku.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        hideAutocomplete();
        triggerSearchIfReady();
      }
    });
    tableSearchSku.addEventListener('blur', () => {
      setTimeout(() => {
        hideAutocomplete();
        triggerSearchIfReady();
      }, 200);
    });
    tableSearchSku.addEventListener('focus', debouncedAutocomplete);
  }
  if (tableSearchQty) {
    tableSearchQty.addEventListener('input', () => setTableSearchMessage(''));
    tableSearchQty.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        triggerSearchIfReady();
      } else if (event.key === 'Tab' && !event.shiftKey) {       
        if (hasSkuValue() && hasValidQty()) {
          event.preventDefault();
          handleTableSearch(true).then(() => {
          });
        }        
      }
    });
    tableSearchQty.addEventListener('blur', triggerSearchIfReady);
  }

  // Add to Cart Button Handler
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', handleAddToCart);
  }

  // --- CSV Parsing ---
  // This parser handles columns in any order by mapping values to header names
  function parseCSV(text) {
    // Helper function to parse CSV line handling quoted values
    function parseCSVLine(line) {
      const result = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        const nextChar = line[i + 1];
        
        if (char === '"') {
          if (inQuotes && nextChar === '"') {
            // Escaped quote
            current += '"';
            i++; // Skip next quote
          } else {
            // Toggle quote state
            inQuotes = !inQuotes;
          }
        } else if (char === ',' && !inQuotes) {
          // End of field
          result.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }
      // Add last field
      result.push(current.trim());
      return result;
    }
    
    const lines = text.trim().split(/\r?\n/).filter(line => line.trim());
    if (lines.length === 0) {
      throw new Error('CSV file is empty');
    }
    
    // Helper function to normalize header names to standard keys
    // Handles variations like "SKU", "Qty", "Job ID", "Pro ID", "Notes"
    function normalizeHeaderName(headerName) {
      // Remove quotes and trim
      let normalized = headerName.trim().replace(/^"|"$/g, '').trim();
      // Convert to lowercase
      normalized = normalized.toLowerCase();
      // Replace spaces and hyphens with underscores
      normalized = normalized.replace(/[\s-]+/g, '_');
      
      // Map common variations to standard keys
      const headerMap = {
        'sku': 'sku',
        'qty': 'quantity',
        'quantity': 'quantity',        
        'job_id': 'job_id',
        'jobid': 'job_id',
        'pro_id': 'pro_id',
        'proid': 'pro_id',
        'notes': 'notes'        
      };
      
      return headerMap[normalized] || normalized;
    }
    
    // Parse header row - column order doesn't matter, we map by name
    const headerRow = parseCSVLine(lines[0]);
    const originalHeaders = headerRow.map(h => h.trim().replace(/^"|"$/g, ''));
    
    // Normalize headers and create mapping from normalized key to column index
    const headerMap = {};
    const normalizedHeaders = [];
    originalHeaders.forEach((orig, idx) => {
      const normalized = normalizeHeaderName(orig);
      normalizedHeaders.push(normalized);
      // Map normalized key to column index (handle duplicates by keeping first occurrence)
      if (!headerMap.hasOwnProperty(normalized)) {
        headerMap[normalized] = idx;
      }
    });
    
    const required = ['sku', 'quantity'];
    const missing = required.filter(k => !normalizedHeaders.includes(k));
    if (missing.length) {
      throw new Error('Missing required columns: SKU and Qty are required.');
    }
    
    // Standard keys we want to extract
    const standardKeys = ['sku', 'quantity', 'job_id', 'pro_id', 'notes'];
    
    return lines.slice(1).map((line, i) => {
      const cols = parseCSVLine(line);
      if (cols.length !== originalHeaders.length) {
        throw new Error(`Malformed CSV at line ${i+2}: Expected ${originalHeaders.length} columns, found ${cols.length}`);
      }
      const row = {};
      
      // Map values using normalized header names
      standardKeys.forEach(key => {
        if (headerMap.hasOwnProperty(key)) {
          const colIndex = headerMap[key];
          let value = cols[colIndex] || '';
          value = value.replace(/^"|"$/g, '').trim();
          row[key] = value;
        } else {
          // If column not found, set empty string
          row[key] = '';
        }
      });
      
      row.parsedLine = i+2;
      return row;
    });
  }

  // --- Product/Variant Lookup by SKU via Suggest Endpoint ---
  async function lookupProductBySKU(sku) {
    // 1. Get product suggestions via Shopify's suggest API
    const suggestRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(sku)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide&resources[options][fields]=title,variants.title,variants.sku`)
      .then(res => res.json());
    const productHandles = (suggestRes.resources?.results?.products || []).map(p => p.handle);
    for (const handle of productHandles) {
      // 2. For each handle, fetch full product details
      const details = await fetch(`/products/${handle}.js`).then(res => res.json());
      // 3. Find matching variant by SKU
      const variant = details.variants.find(v => (v.sku || '').toLowerCase() === sku.toLowerCase());
      if (variant) {
        return {
          sku: variant.sku,
          productName: details.title,
          handle: details.handle,
          variantId: variant.id,
          available: variant.available,
          price: variant.price,
          image: (variant.featured_image && variant.featured_image.src) || (details.images && details.images[0]) || '',
          quantityPriceBreaks: variant.quantity_price_breaks || [],
          variants: details.variants.map(v => ({
            id: v.id,
            title: v.title,
            available: v.available,
            price: v.price,
            sku: v.sku || '',
            quantityPriceBreaks: v.quantity_price_breaks || [],
          })),
        };
      }
    }
    return null; // Not found
  }

  function setTableSearchMessage(message, type = 'info') {
    if (!tableSearchMessage) return;
    tableSearchMessage.textContent = message || '';
    tableSearchMessage.classList.remove('is-error', 'is-success');
    if (!message) return;
    if (type === 'error') {
      tableSearchMessage.classList.add('is-error');
    } else if (type === 'success') {
      tableSearchMessage.classList.add('is-success');
    }
  }

  function getTrimmedSku() {
    return (tableSearchSku?.value || '').trim();
  }

  function hasSkuValue() {
    return getTrimmedSku().length > 0;
  }

  function getQtyValue() {
    const raw = tableSearchQty?.value;
    if (typeof raw === 'undefined') return NaN;
    const parsed = parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function hasQtyValue() {
    return (tableSearchQty?.value || '').trim().length > 0;
  }

  function hasValidQty() {
    const qty = getQtyValue();
    return Number.isFinite(qty) && qty > 0;
  }

  function triggerSearchIfReady() {
    if (!hasSkuValue() || !hasQtyValue()) {
      return;
    }

    if (!hasValidQty()) {
      setTableSearchMessage('Enter a valid quantity (1 or more).', 'error');
      return;
    }

    handleTableSearch();
  }

  // --- Small util: debounce ---
  function debounce(fn, delay) {
    let t;
    return function() {
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), delay);
    };
  }

  // --- Variant suggestions for autocomplete ---
  async function suggestVariantsByQuery(query) {
    toggleLoader(true);
    try {
      const q = query.trim();
      if (!q || q.length < 3) return [];
      const suggestRes = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=show&resources[options][fields]=title,variants.title,variants.sku`).then(r=>r.json());
      const results = [];
      const productHandles = (suggestRes.resources?.results?.products || []).map(p => p.handle);
      for (const handle of productHandles) {
        const details = await fetch(`/products/${handle}.js`).then(res => res.json());
        (details.variants || []).forEach(v => {
          const sku = (v.sku || '').toLowerCase();
          if (sku && sku.includes(q.toLowerCase())) {
            results.push({
              sku: v.sku,
              productName: details.title,
              variantId: v.id,
              handle: details.handle,
              available: v.available,
              price: v.price,
              image: (v.featured_image && v.featured_image.src) || (details.images && details.images[0]) || '',
              quantityPriceBreaks: v.quantity_price_breaks || [],
              variants: details.variants.map(x => ({ id: x.id, title: x.title, available: x.available, price: x.price, sku: x.sku || '', quantityPriceBreaks: x.quantity_price_breaks || [] })),
            });
          }
        });
        if (results.length >= 5) break;
      }
      return results.slice(0, 5);
    } finally {
      toggleLoader(false);
    }
  }

  function renderAutocomplete(items) {
    if (!autocompleteBox) return;
    autocompleteBox.innerHTML = '';
    autocompleteBox.style.display = 'block';
    if (!items || !items.length) {
      const q = (tableSearchSku && tableSearchSku.value) ? tableSearchSku.value.trim() : '';
      if (q.length >= 3) {
        const list = document.createElement('div');
        list.className = 'qo-autocomplete-list';
        const empty = document.createElement('div');
        empty.className = 'qo-autocomplete-empty';
        empty.textContent = 'No products found';
        list.appendChild(empty);
        autocompleteBox.appendChild(list);
        autocompleteBox.style.display = 'block';
      } else {
        autocompleteBox.style.display = 'none';
      }
      return;
    }
    const list = document.createElement('div');
    list.className = 'qo-autocomplete-list';
    items.forEach((it) => {
      const row = document.createElement('div');
      row.className = 'qo-autocomplete-item';
      row.innerHTML = `<div class="qo-ac-sku">${it.sku}</div><div class="qo-ac-title">${it.productName}</div>`;
      row.addEventListener('mousedown', function(e){
        e.preventDefault();
        fillSkuFromAutocomplete(it);
      });
      list.appendChild(row);
    });
    autocompleteBox.appendChild(list);
    autocompleteBox.style.display = 'block';
  }

  function hideAutocomplete() {
    if (!autocompleteBox) return;
    autocompleteBox.innerHTML = '';
    autocompleteBox.style.display = 'none';
  }

  async function handleAutocomplete() {
    if (!tableSearchSku) return;
    const q = tableSearchSku.value;
    if (!q || q.length < 3) {
      hideAutocomplete();
      toggleLoader(false);
      return;
    }
    try {
      const suggestions = await suggestVariantsByQuery(q);
      renderAutocomplete(suggestions);
    } catch (e) {
      hideAutocomplete();
    }
  }

  function fillSkuFromAutocomplete(suggestion) {
    if (!tableSearchSku || !tableSearchQty) return;
    tableSearchSku.value = suggestion.sku;
    hideAutocomplete();
    tableSearchQty.focus();
  }

  document.addEventListener('click', function(e){
    if (!autocompleteBox) return;
    const within = e.target === autocompleteBox || (autocompleteBox.contains && autocompleteBox.contains(e.target)) || e.target === tableSearchSku;
    if (!within) hideAutocomplete();
  });

  // --- CSV Import Handler ---
  async function handleCSVImport(e) {
    if (!csvErrors) return;
    
    csvErrors.textContent = '';
    csvErrors.classList.remove('is-error', 'is-success');
    if (tableErrors) tableErrors.textContent = '';
    const file = e.target.files ? e.target.files[0] : null;
    if (!file || !file.name.endsWith('.csv')) {
      csvErrors.textContent = 'Please select a valid CSV file.';
      csvErrors.classList.add('is-error');
      csvErrors.style.display = 'block';
      return;
    }
    
    // Check if file is empty (0 bytes or very small - likely empty)
    if (file.size === 0 || file.size < 10) {
      csvErrors.textContent = 'The CSV file is empty. Please select a file with data.';
      csvErrors.classList.add('is-error');
      csvErrors.style.display = 'block';
      return;
    }
    
    const reader = new FileReader();
    reader.onload = async function(ev) {
      try {
        toggleLoader(true);

        const text = ev.target.result;
        
        // Check if text content is empty or only whitespace
        if (!text || !text.trim()) {
          csvErrors.textContent = 'The CSV file is empty. Please select a file with data.';
          csvErrors.classList.add('is-error');
          csvErrors.style.display = 'block';
          toggleLoader(false);
          return;
        }
        
        const rows = parseCSV(text);
        
        // Check if CSV has no data rows (only headers)
        if (!rows || rows.length === 0) {
          csvErrors.textContent = 'The CSV file is empty. Please select a file with data rows.';
          csvErrors.classList.add('is-error');
          csvErrors.style.display = 'block';
          toggleLoader(false);
          return;
        }
        
        const importErrors = [];
        for (const row of rows) {
          let quantity = (row.quantity || '').trim();
          if (!quantity) {
            quantity = '1';
          }
          if (!/^[1-9]\d*$/.test(quantity)) {
            importErrors.push(`Line ${row.parsedLine}: Invalid quantity`);
            continue;
          }
          const searchRes = await lookupProductBySKU(row.sku);
          if (searchRes) {
            const jobId = (row.job_id || '').trim().slice(0, 20);
            const quantityNum = parseInt(quantity, 10);

            const existingItem = quickOrderItems.find(item =>
              item.sku === row.sku && item.job_id === jobId
            );

            if (existingItem) {
              const existingQty = parseInt(existingItem.quantity || '1', 10);
              existingItem.quantity = (existingQty + quantityNum).toString();
            } else {
            quickOrderItems.push({
              id: '',
              sku: row.sku,
              pro_id: (row.pro_id || '').slice(0, 20),
              job_id: jobId,
              notes: (row.notes || '').slice(0, 250),
              quantity: quantity,
              productName: searchRes.productName,
              variantId: searchRes.variantId,
              handle: searchRes.handle,
              available: searchRes.available,
              price: searchRes.price,
              image: searchRes.image,
              quantityPriceBreaks: searchRes.quantityPriceBreaks || [],
              variants: searchRes.variants,
              status: searchRes.available ? '' : 'Out of Stock'
            });
            }
          } else {
            importErrors.push(`Line ${row.parsedLine}: SKU "${row.sku}" not found`);
          }
        }
        renderTable();
        
        // Clear the input field after import
        if (csvInput) {
          csvInput.value = '';
        }
        
        // Show success message if all products were added successfully
        if (csvErrors) {
          csvErrors.style.display = 'block';
          if (importErrors.length === 0 && rows.length > 0) {
            csvErrors.textContent = `Successfully imported ${rows.length} item(s) to quick order!`;
            csvErrors.classList.remove('is-error');
            csvErrors.classList.add('is-success');
            // Hide success message after 1 second
            setTimeout(() => {
              if (csvErrors) {
                csvErrors.textContent = '';
                csvErrors.classList.remove('is-success');
              }
            }, 2000);
          } else if (importErrors.length) {
            csvErrors.innerHTML = importErrors.join('<br>');
            csvErrors.classList.remove('is-success');
            csvErrors.classList.add('is-error');
          }
        }
        
        if (quickOrderItems.length > 0) {
          sendItemsToAPI(quickOrderItems);
        }

        toggleLoader(false);
      } catch (ex) {
        if (csvErrors) {
          csvErrors.textContent = ex.message || 'An error occurred while importing the CSV file.';
          csvErrors.classList.remove('is-success');
          csvErrors.classList.add('is-error');
          csvErrors.style.display = 'block';
        }
        toggleLoader(false);
      }
    };
    reader.readAsText(file);
  }

  // --- Manual table search handler ---
  async function handleTableSearch(focusOnNewRow = false) {
    if (tableSearchMessage) {
      setTableSearchMessage('');
    }
    tableErrors.textContent = '';
    const sku = (tableSearchSku?.value || '').trim();
    if (!sku) {
      setTableSearchMessage('Please enter a SKU.', 'error');
      tableSearchSku?.focus();
      return;
    }
    let quantity = parseInt(tableSearchQty?.value || '', 10);
    if (!Number.isFinite(quantity) || quantity < 1) {
      setTableSearchMessage('Enter a valid quantity (1 or more).', 'error');
      tableSearchQty?.focus();
      return;
    }

    toggleLoader(true);
    const searchRes = await lookupProductBySKU(sku);
    toggleLoader(false);

    if (searchRes) {
      // Check if same SKU + job_id combination already exists
      // Since we're adding with empty job_id, check for existing item with same SKU and empty job_id
      const newJobId = ''; // job_id is always empty when adding via manual search
      const existingItem = quickOrderItems.find(item => {
        const existingJobId = (item.job_id || '').trim();
        return item.sku === sku && existingJobId === newJobId;
      });
      if (existingItem) {
        setTableSearchMessage('Item already exists in the list.', 'error');
        return;
      }
      const newItemIndex = quickOrderItems.length;
      quickOrderItems.push({
        id: '',
        sku,
        pro_id: '',
        job_id: '',
        notes: '',
        quantity,
        productName: searchRes.productName,
        variantId: searchRes.variantId,
        handle: searchRes.handle,
        available: searchRes.available,
        price: searchRes.price,
        image: searchRes.image,
        quantityPriceBreaks: searchRes.quantityPriceBreaks || [],
        variants: searchRes.variants,
        status: searchRes.available ? '' : 'Out of Stock'
      });
      renderTable(focusOnNewRow ? newItemIndex : null);
      tableSearchSku && (tableSearchSku.value = '');
      tableSearchQty && (tableSearchQty.value = '');
      sendItemsToAPI(quickOrderItems);
    } else {
      setTableSearchMessage('Item not available.', 'error');
    }
  }

  // Helper function to check if SKU ends with '-SPECIAL' or '-SPECIFIED'
  function isSpecialProduct(sku) {
    if (!sku || typeof sku !== 'string') return false;
    const upperSku = sku.trim().toUpperCase();
    return upperSku.endsWith('-SPECIAL') || upperSku.endsWith('-SPECIFIED');
  }

  // Calculate the actual price for an item based on quantity and price breaks
  // Aggregates quantities for the same SKU across all items with different job IDs
  function calculatePriceForQuantity(item) {
    if (!item.quantityPriceBreaks || item.quantityPriceBreaks.length === 0) {
      return item.price;
    }
    
    // Calculate total quantity for this SKU across all items (regardless of job_id)
    const totalQuantity = quickOrderItems
      .filter(i => i.sku === item.sku)
      .reduce((sum, i) => sum + (parseInt(i.quantity, 10) || 1), 0);
    
    // Sort price breaks by minimum_quantity in descending order
    const sortedBreaks = [...item.quantityPriceBreaks].sort((a, b) => b.minimum_quantity - a.minimum_quantity);
    
    // Find the applicable price break based on total quantity
    for (const priceBreak of sortedBreaks) {
      if (totalQuantity >= priceBreak.minimum_quantity) {
        return priceBreak.price;
      }
    }
    
    // If no price break applies, return the base price
    return item.price;
  }

  // Update Add to Cart button state based on items count
  function updateAddToCartButtonState() {
    if (addToCartBtn) {
      addToCartBtn.disabled = quickOrderItems.length === 0;
    }
  }

  function renderTable(focusRowIndex = null) {
    if (!tableBody) return;

    tableBody.innerHTML = '';
    if (quickOrderItems.length) {
      quickOrderItems.forEach((item, idx) => {
        const tr = document.createElement('tr');
        const isSpecial = isSpecialProduct(item.sku);
        const actualPrice = calculatePriceForQuantity(item);
        const priceDisplay = isSpecial ? 'TBD' : (actualPrice ? (Number(actualPrice)/100).toFixed(2) : '');
        const priceCellContent = isSpecial ? 'TBD' : `${currencySymbol}${priceDisplay}`;
        const notesCellContent = isSpecial
          ? `<div class="qo-notes-wrapper">
              <textarea class="qo-input-notes" data-index="${idx}" maxlength="250" rows="2" placeholder="Notes (required)">${item.notes || ''}</textarea>
              <div class="qo-special-product-note">Enter the SKU for the Final Configuration</div>
            </div>`
          : `<textarea class="qo-input-notes" data-index="${idx}" maxlength="250" rows="2" placeholder="Notes (optional)">${item.notes || ''}</textarea>`;
        tr.innerHTML = `
          <td>${item.image ? `<img src="${item.image}" alt="" style="width:40px;height:40px;object-fit:cover;"/>` : '<img src="https://cdn.shopify.com/s/files/1/0674/9772/1901/files/placeholder-plp.png" alt="" style="width:40px;"/>'}</td>
          <td class="qo-search-cell--sku">${item.sku || ''}</td>
          <td><input type="number" min="1" step="1" class="qo-input-qty" data-index="${idx}" value="${item.quantity || 1}" /></td>
          <td>${item.productName || ''}</td>
          <td><input type="text" class="qo-input-job" data-index="${idx}" value="${item.job_id || ''}" maxlength="20" placeholder="Job ID (optional)" /></td>
          <td><input type="text" class="qo-input-pro" data-index="${idx}" value="${item.pro_id || ''}" maxlength="20" placeholder="Pro ID (optional)" /></td>
          <td>${notesCellContent}</td>
          <td class="qo-price">${priceCellContent}</td>
          <td><button type="button" data-index="${idx}" class="quick-order-remove-btn" aria-label="Remove"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.25 3H13.5V2.25C13.5 1.65326 13.2629 1.08097 12.841 0.65901C12.419 0.237053 11.8467 0 11.25 0H6.75C6.15326 0 5.58097 0.237053 5.15901 0.65901C4.73705 1.08097 4.5 1.65326 4.5 2.25V3H0.75C0.551088 3 0.360322 3.07902 0.21967 3.21967C0.0790178 3.36032 0 3.55109 0 3.75C0 3.94891 0.0790178 4.13968 0.21967 4.28033C0.360322 4.42098 0.551088 4.5 0.75 4.5H1.5V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H15C15.3978 19.5 15.7794 19.342 16.0607 19.0607C16.342 18.7794 16.5 18.3978 16.5 18V4.5H17.25C17.4489 4.5 17.6397 4.42098 17.7803 4.28033C17.921 4.13968 18 3.94891 18 3.75C18 3.55109 17.921 3.36032 17.7803 3.21967C17.6397 3.07902 17.4489 3 17.25 3ZM7.5 14.25C7.5 14.4489 7.42098 14.6397 7.28033 14.7803C7.13968 14.921 6.94891 15 6.75 15C6.55109 15 6.36032 14.921 6.21967 14.7803C6.07902 14.6397 6 14.4489 6 14.25V8.25C6 8.05109 6.07902 7.86032 6.21967 7.71967C6.36032 7.57902 6.55109 7.5 6.75 7.5C6.94891 7.5 7.13968 7.57902 7.28033 7.71967C7.42098 7.86032 7.5 8.05109 7.5 8.25V14.25ZM12 14.25C12 14.4489 11.921 14.6397 11.7803 14.7803C11.6397 14.921 11.4489 15 11.25 15C11.0511 15 10.8603 14.921 10.7197 14.7803C10.579 14.6397 10.5 14.4489 10.5 14.25V8.25C10.5 8.05109 10.579 7.86032 10.7197 7.71967C10.8603 7.57902 11.0511 7.5 11.25 7.5C11.4489 7.5 11.6397 7.57902 11.7803 7.71967C11.921 7.86032 12 8.05109 12 8.25V14.25ZM12 3H6V2.25C6 2.05109 6.07902 1.86032 6.21967 1.71967C6.36032 1.57902 6.55109 1.5 6.75 1.5H11.25C11.4489 1.5 11.6397 1.57902 11.7803 1.71967C11.921 1.86032 12 2.05109 12 2.25V3Z" fill="#2B2B2B"/>
</svg></button></td>
          <input type="hidden" class="qo-input-id" data-index="${idx}" value="${item.id || ''}" />
        `;
        tableBody.appendChild(tr);
      });
    }

    tableBody.querySelectorAll('.quick-order-remove-btn').forEach(btn => {
      btn.addEventListener('click', async function() {
        const i = parseInt(btn.dataset.index);
        const itemToDelete = quickOrderItems[i];
        if (itemToDelete) {
          const idInput = tableBody.querySelector(`.qo-input-id[data-index="${i}"]`);
          if (idInput && idInput.value) {
            itemToDelete.id = idInput.value;
          }
          await deleteItemsFromAPI([itemToDelete]);
          setTableSearchMessage('');
        }
        quickOrderItems.splice(i, 1);
        renderTable();
      });
    });

    const debouncedApiCall = debounce(() => {
      sendItemsToAPI(quickOrderItems);
    }, 500);

    tableBody.querySelectorAll('.qo-input-pro').forEach(input => {
      input.addEventListener('input', e => {
        const i = parseInt(e.target.dataset.index);
        if (e.target.value && e.target.value.length > 20) {
          e.target.value = e.target.value.slice(0, 20);
        }
        quickOrderItems[i].pro_id = e.target.value;
        debouncedApiCall();
      });
    });

    tableBody.querySelectorAll('.qo-input-job').forEach(input => {
      input.addEventListener('input', e => {
        const i = parseInt(e.target.dataset.index);
        if (e.target.value && e.target.value.length > 20) {
          e.target.value = e.target.value.slice(0, 20);
        }
        quickOrderItems[i].job_id = e.target.value;
        debouncedApiCall();
      });
    });

    tableBody.querySelectorAll('.qo-input-notes').forEach(textarea => {
      textarea.addEventListener('input', e => {
        const i = parseInt(e.target.dataset.index);
        if (e.target.value && e.target.value.length > 250) {
          e.target.value = e.target.value.slice(0, 250);
        }
        quickOrderItems[i].notes = e.target.value;
        
        // Remove error class when user starts typing
        if (e.target.value && e.target.value.trim()) {
          e.target.classList.remove('qo-input-notes--error');
        }
        
        debouncedApiCall();
      });
    });

    tableBody.querySelectorAll('.qo-input-qty').forEach(input => {
      input.addEventListener('change', e => {
        const i = parseInt(e.target.dataset.index);
        const val = parseInt(e.target.value, 10);
        quickOrderItems[i].quantity = Number.isFinite(val) && val > 0 ? val : 1;
        e.target.value = quickOrderItems[i].quantity;
        
        // Update prices for all items with the same SKU (since quantity affects all rows with same SKU)
        renderTable();
        sendItemsToAPI(quickOrderItems);
      });
    });

    // Update Add to Cart button state
    updateAddToCartButtonState();
   
    if (focusRowIndex !== null && focusRowIndex >= 0 && focusRowIndex < quickOrderItems.length) {
      setTimeout(() => {
        const jobIdInput = tableBody.querySelector(`.qo-input-job[data-index="${focusRowIndex}"]`);
        if (jobIdInput) {
          jobIdInput.focus();
        }
      }, 0);
    }
  }

  // --- Add to Cart ---
  async function handleAddToCart() {
    addToCartMsg.textContent = '';
    tableErrors.textContent = '';
    const validItems = quickOrderItems.filter(item => item.variantId && !item.status && item.available && /^[1-9]\d*$/.test(item.quantity));
    if (!validItems.length) {
      addToCartMsg.textContent = 'No valid items to add.';
      return;
    }
    
    // Validate that special products have notes filled
    const specialProductsWithoutNotes = validItems.filter(item => {
      const isSpecial = isSpecialProduct(item.sku);
      return isSpecial && (!item.notes || !item.notes.trim());
    });
    
    if (specialProductsWithoutNotes.length > 0) {
      // Remove any existing error classes first
      tableBody.querySelectorAll('.qo-input-notes--error').forEach(textarea => {
        textarea.classList.remove('qo-input-notes--error');
      });
      
      // Add error class to empty required notes fields
      specialProductsWithoutNotes.forEach(item => {
        const itemIndex = quickOrderItems.findIndex(i => i === item);
        if (itemIndex !== -1) {
          const textarea = tableBody.querySelector(`.qo-input-notes[data-index="${itemIndex}"]`);
          if (textarea) {
            textarea.classList.add('qo-input-notes--error');
            // Scroll to the first error field
            if (specialProductsWithoutNotes[0] === item) {
              textarea.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }
        }
      });
      
      const skus = specialProductsWithoutNotes.map(item => item.sku).join(', ');
      //addToCartMsg.textContent = `Notes are required for special products. Please fill in notes for: ${skus}`;
      tableErrors.textContent = `Notes are required for special products. Please fill in notes for: ${skus}`;
      return;
    }
    
    // Remove error classes if validation passes
    tableBody.querySelectorAll('.qo-input-notes--error').forEach(textarea => {
      textarea.classList.remove('qo-input-notes--error');
    });
    
    try {
      addToCartBtn.disabled = true;
      addToCartMsg.textContent = 'Adding to cart...';
      
      // Get currency code from hidden input
      const currencyInput = document.getElementById('current_currency');
      const currencyCode = (currencyInput && currencyInput.value) ? currencyInput.value : 'USD';
      
      const items = validItems.map(item => {
        const isSpecial = isSpecialProduct(item.sku);
        const properties = {};
        // For special products, use "Configured SKU" instead of "_Item Notes"
        if (isSpecial) {
          properties['Configured SKU'] = item.notes || '';
        } else {
          properties['_Item Notes'] = item.notes || '';
        }
        properties['Pro ID'] = item.pro_id || '';
        properties['Job ID'] = item.job_id || '';
        
        // Calculate unit amount (price is in cents, convert to dollars)
        const actualPrice = calculatePriceForQuantity(item);
        const unitAmount = (actualPrice / 100).toFixed(2);
        const quantity = parseInt(item.quantity, 10);
        const totalAmount = (parseFloat(unitAmount) * quantity).toFixed(2);
        
        // Add price properties
        properties['_li_unit_amount'] = unitAmount;
        properties['_li_total_amount'] = totalAmount;
        properties['_currency_code'] = currencyCode;
        
        return {
          id: item.variantId,
          quantity: quantity,
          properties: properties
        };
      });
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Add to cart failed');
      }
      await deleteItemsFromAPI(validItems);
      addToCartMsg.textContent = 'Items added to cart! Redirecting…';
      setTimeout(function() { window.location.href = '/cart'; }, 300);
    } catch (err) {
      addToCartMsg.textContent = err.message;
    } finally {
      addToCartBtn.disabled = false;
    }
  }

  // --- Delete Items from API ---
  async function deleteItemsFromAPI(items) {
    try {
      const customerIdInput = document.getElementById('customer_id');
      if (!customerIdInput || !customerIdInput.value) {
        console.log('No customer ID found, skipping API delete');
        return;
      }

      const customerId = customerIdInput.value;
      const app_url = document.getElementById('app_url')?.value || null;
      const apiUrl = app_url+'/api/quick-order';

      const itemsData = items.map((item, index) => {
        let itemId = item.id || '';
        if (tableBody) {
          const idInput = Array.from(tableBody.querySelectorAll('.qo-input-id')).find(input => {
            const idx = parseInt(input.dataset.index);
            return idx >= 0 && idx < quickOrderItems.length && quickOrderItems[idx] === item;
          });
          if (idInput && idInput.value) {
            itemId = idInput.value;
          }
        }
        return {
          id: itemId,
          shopify_customer_id: customerId,
          sku: item.sku || '',
          job_id: item.job_id || ''
        };
      });

      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: itemsData
        })
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Items deleted from API successfully:', result);
    } catch (error) {
      console.error('Error deleting items from API:', error);
    }
  }

  // --- Send Items to API (Upsert) ---
  async function sendItemsToAPI(items) {
    try {
      const customerIdInput = document.getElementById('customer_id');
      if (!customerIdInput || !customerIdInput.value) {
        console.log('No customer ID found, skipping API upsert');
        return;
      }

      const customerId = customerIdInput.value;
      const app_url = document.getElementById('app_url')?.value || null;
      const apiUrl = app_url+'/api/upsert-quick-order';

      const itemsData = items.map((item, index) => {
        const idInput = tableBody?.querySelector(`.qo-input-id[data-index="${index}"]`);
        const itemId = idInput ? idInput.value : (item.id || '');
        return {
          id: itemId,
          sku: item.sku || '',
          pro_id: item.pro_id || '',
          job_id: item.job_id || '',
          notes: item.notes || '',
          qty: parseInt(item.quantity, 10) || 1,
          shopify_customer_id: customerId
        };
      });

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          shopify_customer_id: customerId,
          items: itemsData
        })
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      const result = await response.json();
      
      // Extract the response array - handle different response structures
      let responseItems = [];
      
      // Handle the 'processed' array structure where each item has index and data
      if (result && Array.isArray(result.processed)) {
        responseItems = result.processed.map(processedItem => ({
          ...processedItem.data,
          responseIndex: processedItem.index
        }));
      } else if (result && Array.isArray(result.data)) {
        responseItems = result.data;
      } else if (result && Array.isArray(result)) {
        responseItems = result;
      } else if (result && result.items && Array.isArray(result.items)) {
        responseItems = result.items;
      }
      
      // Update IDs for each item in the response
      responseItems.forEach((apiItem) => {
        if (!apiItem.id) {
          return;
        }
        
        // Use the responseIndex from the API if available, otherwise use array position
        const responseIndex = apiItem.responseIndex !== undefined ? apiItem.responseIndex : responseItems.indexOf(apiItem);
        
        let matchingIdInput = null;
        let matchingIndex = -1;
        
        // Strategy 1: Match by existing ID (for updates)
        if (tableBody) {
          const existingInput = Array.from(tableBody.querySelectorAll('.qo-input-id')).find(input => input.value === apiItem.id.toString());
          if (existingInput) {
            matchingIdInput = existingInput;
            matchingIndex = parseInt(existingInput.dataset.index);
          }
        }
        
        // Strategy 2: Match by response index for new items (empty ID)
        if (!matchingIdInput && tableBody && responseIndex >= 0 && responseIndex < itemsData.length) {
          const sentData = itemsData[responseIndex];
          const idInput = tableBody.querySelector(`.qo-input-id[data-index="${responseIndex}"]`);
          
          if (idInput) {
            const currentValue = idInput.value;
            
            // Match if the input is empty and SKUs match
            if ((!currentValue || currentValue === '')) {
              if (responseIndex < quickOrderItems.length) {
                const currentItem = quickOrderItems[responseIndex];
                if (currentItem && sentData.sku === currentItem.sku) {
                  matchingIdInput = idInput;
                  matchingIndex = responseIndex;
                }
              }
            }
          }
        }
        
        // Strategy 3: Match by SKU + job_id + pro_id combination
        if (!matchingIdInput && apiItem.sku && tableBody) {
          const allRows = Array.from(tableBody.querySelectorAll('tr'));
          for (const row of allRows) {
            const idInput = row.querySelector('.qo-input-id');
            if (!idInput) continue;
            
            const index = parseInt(idInput.dataset.index);
            if (index >= 0 && index < quickOrderItems.length) {
              const skuCell = row.querySelector('.qo-search-cell--sku');
              const jobInput = row.querySelector('.qo-input-job');
              const proInput = row.querySelector('.qo-input-pro');
              
              const rowSku = skuCell ? skuCell.textContent.trim() : '';
              const rowJobId = jobInput ? jobInput.value : '';
              const rowProId = proInput ? proInput.value : '';
              
              const apiSku = apiItem.sku || '';
              const apiJobId = apiItem.job_id || '';
              const apiProId = apiItem.pro_id || '';
              
              if (rowSku === apiSku && 
                  (rowJobId || '') === (apiJobId || '') &&
                  (rowProId || '') === (apiProId || '')) {
                // Only match if ID is not already set to avoid conflicts
                if (!idInput.value || idInput.value === '') {
                  matchingIdInput = idInput;
                  matchingIndex = index;
                  break;
                }
              }
            }
          }
        }
        
        // Update the matched item's ID
        if (matchingIdInput && matchingIndex >= 0) {
          const newId = apiItem.id.toString();
          matchingIdInput.value = newId;
          
          if (matchingIndex < quickOrderItems.length) {
            quickOrderItems[matchingIndex].id = newId;
          }
        }
      });
    } catch (error) {
      console.error('Error sending items to API:', error);
    }
  }

  // --- Load Quick Order Items from API on Page Load ---
  async function loadQuickOrderItemsFromAPI() {
    try {
      const customerIdInput = document.getElementById('customer_id');
      if (!customerIdInput || !customerIdInput.value) {
        console.log('No customer ID found, skipping API load');
        return;
      }

      const customerId = customerIdInput.value;
      const app_url = document.getElementById('app_url')?.value || null;
      const apiUrl = app_url+"/api/quick-order?shopify_customer_id="+encodeURIComponent(customerId);

      toggleLoader(true);

      if (tableBody) {
        tableBody.innerHTML = '<tr><td colspan="9">Loading quick order items...</td></tr>';
      }

      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      const apiData = await response.json();

      const items = Array.isArray(apiData) ? apiData : (apiData.data || []);

      if (!items || items.length === 0) {
        console.log('No quick order items found in API response');
        toggleLoader(false);
        renderTable();
        return;
      }

      quickOrderItems = [];
      const loadErrors = [];

      for (const item of items) {
        const sku = item.sku || item.SKU || '';
        if (!sku) {
          loadErrors.push(`Item missing SKU: ${JSON.stringify(item)}`);
          continue;
        }

        const productDetails = await lookupProductBySKU(sku);
        if (productDetails) {
          let quantity = parseInt(item.quantity || item.qty || 1, 10);
          if (!Number.isFinite(quantity) || quantity < 1) {
            quantity = 1;
          }

          quickOrderItems.push({
            id: item.id || item.ID || '',
            sku: sku,
            pro_id: (item.pro_id || item.proId || '').toString().slice(0, 20),
            job_id: (item.job_id || item.jobId || '').toString().slice(0, 20),
            notes: (item.notes || item.Notes || '').toString().slice(0, 250),
            quantity: quantity,
            productName: productDetails.productName,
            variantId: productDetails.variantId,
            handle: productDetails.handle,
            available: productDetails.available,
            price: productDetails.price,
            image: productDetails.image,
            quantityPriceBreaks: productDetails.quantityPriceBreaks || [],
            variants: productDetails.variants,
            status: productDetails.available ? '' : 'Out of Stock'
          });
        } else {
          loadErrors.push(`SKU "${sku}" not found in store`);
        }
      }

      renderTable();

      if (loadErrors.length && tableErrors) {
        tableErrors.innerHTML = loadErrors.join('<br>');
      }

      toggleLoader(false);
    } catch (error) {
      console.error('Error loading quick order items from API:', error);
      renderTable();
      toggleLoader(false);
    }
  }

  window.quickOrder = {
    quickOrderItems,
    renderTable,
    loadQuickOrderItemsFromAPI,
  };

  // Initialize button state (disabled until items are loaded)
  updateAddToCartButtonState();

  loadQuickOrderItemsFromAPI();
});
